import City from "./city";
import Project from "@/menu/models/class/loginInfo/project";

export default class User {
  #active = false
  #superAdmin = false
  #external = false
  #document = 0
  #id = ''
  #email = ""
  #name = ''
  #photoUrl = ""
  #position = ""
  #cities = []
  #portalIds = []
  #projects = []

  static fromJSONResponse(json) {
    return new User()
      .setActive(json.active)
      .setSuperAdmin(json.super_admin)
      .setExternal(json.external)
      .setDocument(json.document)
      .setId(json.id)
      .setEmail(json.email)
      .setName(json.name)
      .setPhotoUrl(json.photo_url)
      .setPosition(json.position)
      .setCities(json.cities.map(city => City.fromJSONResponse(city)))
      .setPortalIds(json.portal_ids || [])
      .setProjects(json.projects.map(project => Project.fromJSONResponse(project)))
  }


  getActive() {
    return this.#active
  }

  setActive(value) {
    this.#active = value
    return this
  }

  getSuperAdmin() {
    return this.#superAdmin
  }

  setSuperAdmin(value) {
    this.#superAdmin = value
    return this
  }

  getExternal() {
    return this.#external
  }

  setExternal(value) {
    this.#external = value
    return this
  }

  getDocument() {
    return this.#document
  }

  setDocument(value) {
    this.#document = value
    return this
  }

  getId() {
    return this.#id
  }

  setId(value) {
    this.#id = value
    return this
  }

  getEmail() {
    return this.#email
  }

  setEmail(value) {
    this.#email = value
    return this
  }

  getName() {
    return this.#name
  }

  setName(value) {
    this.#name = value
    return this
  }

  getPhotoUrl() {
    return this.#photoUrl
  }

  setPhotoUrl(value) {
    this.#photoUrl = value
    return this
  }

  getPosition() {
    return this.#position
  }

  setPosition(value) {
    this.#position = value
    return this
  }

  getCities() {
    return this.#cities
  }

  setCities(value) {
    this.#cities = value
    return this
  }

  getPortalIds() {
    return this.#portalIds
  }

  setPortalIds(value) {
    this.#portalIds = value
    return this
  }

  getProjects() {
    return this.#projects
  }

  setProjects(value) {
    this.#projects = value
    return this
  }
}
